<template>
  <div class="flex items-center space-x-4">
    <NuxtLink
        to="/admin"
        class="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-red-700 bg-red-50 hover:bg-green-600 hover:text-white transition-colors truncate"
    >
      <i class="pi pi-palette mr-2"></i>
      {{ t('nav.manage')}}
    </NuxtLink>
  </div>
</template>

<script setup>
const { t } = useI18n()
</script>